module.exports = __webpack_public_path__ + "static/media/refer-friend-icon.bb5add6d.svg";